module.exports = __webpack_public_path__ + "static/przed-pensjonatem-zima_thumb-0ed71de7c174d9100cf53a530c5d0305.jpg";